module.exports = __webpack_public_path__ + "static/media/rom17.f2234d94.jpg";